
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { withStyles } from '@material-ui/core/styles';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import CardHeader from '@material-ui/core/CardHeader';
import { WindowScroller } from 'react-virtualized';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import NodeButtonOptions from './NodeButtonOptions'
import {addNodeUnderParent, changeNodeAtPath,removeNodeAtPath} from 'react-sortable-tree';
import AskAlert from '../common/AskAlert';
import{ NODE_TYPE_COMPONENT,NODE_TYPE_DELIVERABLE,NODE_TYPE_WORKPACKAGE } from '../common/redux/constantes';
import NodeTypeSelection from './NodeTypeSelection';
import NodeInformation from './NodeInformation';
import history from '../../common/history';
import Brightness1 from '@material-ui/icons/Brightness1';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  CREATE_PROJECT_MODEL_ACTION_CREATE,CREATE_PROJECT_MODEL_ACTION_SHOW, CREATE_PROJECT_MODEL_ACTION_EDIT
} 
from '../common/redux/constantes';
import { WBS_isNodeValid } from '../common/redux/validators';

//Alerta
import Alerta from '../common/Alerta';
import MySnackBar from '../common/MySnackBar';

const styles = theme => ({
  button: {
    marginTop: theme.spacing.unit + 5,
    marginRight:'5px'
  },
  input: {
    display: 'none',
  },
});


class WorkStructure extends Component 
{
  constructor(props) {
    super(props);
    //Si entra a la pagina sin saber que project está viendo lo manda a /
    if(!this.props.project || !this.props.project.project)
      history.push("/");
    

    //Default state
    this.state = {
      openDeleteAlert:false,
      selectedItem:null,
      openSelectionDialog: false,
      openAlerta:false,
      messageAlerta:"",
      openNodeInformation:false,
      selectedType:null,
      actionModal:CREATE_PROJECT_MODEL_ACTION_CREATE,
      treeData: [
      ],
    };


    //Binding
    this.cloneNode = this.cloneNode.bind(this);
    this.addNode = this.addNode.bind(this);
    this.updateNode = this.updateNode.bind(this);
    this.removeNode = this.removeNode.bind(this);
    this.closeNodeInformationDialog = this.closeNodeInformationDialog.bind(this);
    this.closeSnackBar = this.closeSnackBar.bind(this);
    this.showInformation = this.showInformation.bind(this);
    this.editInformation = this.editInformation.bind(this);
    this.resetInformationConfig = this.resetInformationConfig.bind(this);
  }

  componentDidMount()
  {
    //Si entra a la pagina sin saber que project está viendo lo manda a /
    if(!this.props.project || !this.props.project.project)
    {
      history.push("/");
      return;
    }

    //Obtenemos el árbol completo
    this.props.actions.fetchWbs(this.props.project.project)
    .then(res=>{
      this.setState({treeData:[res.tree]});
    });


  }



  //Clona un nodo, por el momento está a veremos..
  cloneNode(node,path){
    //El nuevo nodo sera lo mismo exceptuando el id.
    this.setState(state => ({
        treeData: addNodeUnderParent({
        treeData: state.treeData,
        parentKey: path[path.length - 2], 
        expandParent: true,
        getNodeKey:this.getNodeKey,
        newNode: {
          ...node, id:node.id+Math.random()
        }
        }).treeData
    }))
  }



  /**
 * DELETE NODE
 */

  //Ask before delete
  askDeleteNode= (selectedItem)=>
  {
    this.setState({openDeleteAlert:true, selectedItem:selectedItem});
  }


  //Cancel Deleting
  cancelDelete = () =>{
    this.setState({openDeleteAlert:false, selectedItem:null});
  }

  //Elimina un nodo
  removeNode() 
  {
    //Si no ha seleccionado el nodo, no podemos eliminar nada.
    if (!this.state.selectedItem)
    {
      this.cancelDelete();
      return;
    }
    let {node} = this.state.selectedItem;
    //Si tiene hijos no podra eliminar.
    if(!node || (node.children && node.children.length > 0))
    {
      this.cancelDelete();
      return;
    }
    switch(node.tipo)
    {
      case NODE_TYPE_COMPONENT:
        this.props.actions.deleteComponent(node.component)
        .then(()=>{
          this.removeTreeNode();
        })
        return;
      case NODE_TYPE_DELIVERABLE:
        this.props.actions.deleteDeliverable(node.deliverable)
        .then(()=>{
          this.removeTreeNode();
        })
        return;
      case NODE_TYPE_WORKPACKAGE:
        this.props.actions.deleteWorkpackage(node.workpackage)
        .then(()=>{
          this.removeTreeNode();
        })
        return;
      default:
        return;
    }
  }

  removeTreeNode()
  {
    let {path} = this.state.selectedItem;
    this.setState({ 
      treeData : removeNodeAtPath({
        treeData: this.state.treeData,
        path: path,   // You can use path from here
        getNodeKey:this.getNodeKey,
        ignoreCollapsed: false
      }),
      openDeleteAlert:false,
      selectedItem:null
    })
  }

  /**
   * ADDING NODE
   */
  
  //Abre un dialogo para seleccionar el tipo de nodo a crear componente(level)/deliverable(milestone)/workpackage
  openSelectionDialog = (rowInfo) => {
    this.setState({
      openSelectionDialog: true,
      selectedItem:rowInfo
    });
  };

  //Hace verificaciones a la hora de crear un nodo sobre los tipos.
  verifyCreationRules = (nodeType)=>{
    // 0:NODE_TYPE_COMPONENT, 1: NODE_TYPE_DELIVERABLE, 2: NODE_TYPE_WORKPACKAGE 
    let node = this.state.selectedItem;
    
    //Estos son hoja
    if(node.tipo === NODE_TYPE_WORKPACKAGE)
      return "Work Package can't have children.";
    
    //Estos solo pueden tener workpackage de hijos
    if(node.tipo === NODE_TYPE_DELIVERABLE && nodeType !== NODE_TYPE_WORKPACKAGE)
      return "Deliverables only can have Work Package as a child";

    //Los entregables son los unicos q pueden tener work package como hijo.
    if(node.tipo===NODE_TYPE_COMPONENT && nodeType === NODE_TYPE_WORKPACKAGE)
      return "Just Deliverables can have Work Package as a child";

    //Los component solo pueden tener hijos del mismo tipo
    // if(node.tipo===NODE_TYPE_COMPONENT && node.children && node.children.length>0 && node.children[0].tipo !== nodeType)
    //   return "This Work Component must have all children of the same type";

    return "";
  }
 
  //Para cerrar el dialogo de seleccion del tipo a la hora de crear un nodo 
  closeSelectionDialog = (nodeType)=>
  {
    this.setState({
      openSelectionDialog:false,
    });

    if(!nodeType || !this.state.selectedItem)
    {
      this.setState({
        selectedItem:null,
        selectedPath:null,
      });
      return;
    }

    //Verificando tipos
    let errorMessage = this.verifyCreationRules(nodeType);

    //Mostrar error si se presenta
    if( errorMessage !== "")
    {
      this.setState({messageAlerta:errorMessage, openAlerta:true, selectedItem:null, selectedPath:null});
      return;
    }
    //Si verificó mostramos el modal para setear la información.
    this.setState({openNodeInformation:true, selectedType:nodeType});
  }

  //Solo cierra el dialogo para mostrar la información a setear o a mostrar  
  closeNodeInformationDialog(){
    this.setState({openNodeInformation:false, selectedType:null})
  }


  //Obtiene el tipo seleccionado a la hora de crear
  getTypeSelected()
  {
    return this.state.selectedType;
  }


  //Agrega un nodo a nuestro arbol
  addNode(new_node)
  {
    //Del estado escojemos el nodo seleccionado
    let node = this.state.selectedItem;
    //Del nodo nuevo empezamos a crear un nuevo nodo
    new_node.key = this.getNodeKey({node:new_node});
    new_node.expanded = true; 
    //Ahora refrescamos el árbol
    let newTree = addNodeUnderParent({
            treeData: this.state.treeData,
            newNode: new_node,
            expandParent: true,
            parentKey: this.getNodeKey({node:node}),
            getNodeKey: this.getNodeKey
     });
     this.setState({treeData: newTree.treeData});
     //Cerramos el dialogo
     this.closeNodeInformationDialog();
  }

  //Edita un nodo a nuestro arbol
  updateNode(edited_node)
  {
    edited_node.expanded = true; 
    //Ahora refrescamos el árbol
    let newTree = changeNodeAtPath({
            treeData: this.state.treeData,
            path:this.state.selectedPath,
            expandParent: true,
            newNode:edited_node,
            getNodeKey: this.getNodeKey
     });
     this.setState({treeData: newTree});
     //Cerramos el dialogo
     this.closeNodeInformationDialog();
  }

  showInformation(node)
  {
    //Configuraciones para poder abrir el diálogo y mostrar la información
    this.setState({openNodeInformation:true, selectedType:node.tipo, selectedItem:node, actionModal:CREATE_PROJECT_MODEL_ACTION_SHOW});  
  }

  editInformation(node, path)
  {
    //Configuraciones para poder abrir el diálogo y editar la información
    this.setState({openNodeInformation:true, selectedType:node.tipo,selectedPath:path, selectedItem:node, actionModal:CREATE_PROJECT_MODEL_ACTION_EDIT});  
  }

  /*Valid a especific node */
  isNodeValid(node)
  {
    if(!node)
      return false;
    return WBS_isNodeValid(node);
  }


  /*Mostrar titulo y acciones por cada componente */
  renderButton(node, path)
  {
      const { classes } = this.props;
      return (
        <div style={{display:'inline-block !important'}}>
          <h5 style={{fontsize:'1em', marginRight:'200px', padding:0, marginLeft:'5px', float:'left'}}>
            {node.name+"      "}
          </h5>
          <div style={{position:'absolute', right:'0'}}>
             {
              (node.tipo !== NODE_TYPE_WORKPACKAGE && !this.isNodeValid(node))?
                (<Brightness1 style={{color:"#f44336",margin:0, paddingTop:15,borderRadius: '50%'}}/>)
              :
                (<Brightness1 style={{color:"#76FF03",margin:0, paddingTop:15,  borderRadius: '50%'}}/>)
            }
            {node.tipo<NODE_TYPE_WORKPACKAGE?
            (
              <Button onClick={()=>this.openSelectionDialog(node)} 
                size="small"  style={{backgroundColor:'#BDBDBD', color:'white'}} className={classes.button} aria-label="Add">
                <AddIcon  style={{borderRadius:'none'}}/>
              </Button>
            ):null}
            {(!node.root && (!node.children || node.children.length===0))?(
              <Button onClick={()=>this.askDeleteNode({node,path})} size="small"  style={{backgroundColor:'#BDBDBD', color:'white'}} className={classes.button} aria-label="Delete">
                <DeleteIcon style={{borderRadius:'none'}} />
              </Button>
            ):null}
            {true?(
              <NodeButtonOptions editInformation={this.editInformation} showInformation={this.showInformation} cloneNode={this.cloneNode} node={node} path={path} buttonClass={classes.button} />
            ):null}
          </div>
        </div> 
      )
  }


  /*A la hora de generar los nodos se le ve su tipo para colocarlo del color especifico */
  generateNodeProperties(node)
  {
    let className = "nodo_component";
    if(node.tipo === 2){
      className = "nodo_deliverable"
    }else if(node.tipo ===3){
      className = "nodo_workpackage"
    }
    return className
  }

  /*El key de cada nodo sera el id mas el tipo ya que puede repetirse el id ya q son tres tablas distintas componente/deliverable/workpackage  */
  getNodeKey({ node }){ 
    return node.id+"_"+node.tipo
  }


  //Close the snackbar
  closeSnackBar()
  {
    this.props.actions.closeSnackBar();
  }

  //Cuando se cierra el diálogo la acción vuelve a por defecto(crear)
  resetInformationConfig()
  {
    this.setState({actionModal:CREATE_PROJECT_MODEL_ACTION_CREATE});
  }

  render() 
  {
    const stylesNuevo = {
      block: {
        maxWidth: 250,
      },
      radioButton: {
        marginBottom: 16,
      },
      card: {
        padding: "1.5%",
        textAlign: 'center',
        color:"green",
        display:"inline-block",
        float:"center"
      },
    };
    let validTree = this.isNodeValid(this.state.treeData[0])?"WBS validation: valid":"WBS validation: invalid";
    return (
      <div style={{height:"100%", maxHeight:"100%"}} >
        {this.state.treeData.length>0?null:<LinearProgress />}
        <div style={{  margin:0, padding:0}}>
          <CardHeader

            title={this.props.project? "Planing of " + this.props.project.name: "Redirecting to projects"} 
            style={stylesNuevo.card}
             />
             <span style={{ float:"right", fontSize:"1.4em", marginRight:"5%", marginTop:"1.5%"}}>{validTree}</span>
        </div>
          {this.state.treeData.length > 0?
          <WindowScroller style={{maxHeight:"100%"}}>
            {windowScrollerProps => (
              <SortableTree
                    className='tree_wbs'
                    style={{height:'900px',maxHeight:"100%", backgroundColor:'white', padding:10}}
                    treeData={this.state.treeData}
                    getNodeKey={this.getNodeKey}
                    onChange={treeData => this.setState({ treeData })}
                    canDrag={false}
                    canDrop={()=>false}
                    rowHeight={100}
                    isVirtualized={true}
                    shouldCopyOnOutsideDrop={false}
                    canNodeHaveChildren={node => {return false}}
                    generateNodeProps={({ node, path }) => ({
                        title: (
                          this.renderButton(node, path)
                        ),
                        key:this.getNodeKey({node:node}),
                        className:this.generateNodeProperties(node)
                    })}
              />
            )}
        </WindowScroller>
        :null
        }
          
        

        <NodeTypeSelection
          open={this.state.openSelectionDialog}
          onClose={this.closeSelectionDialog}
        />

        {
          (!this.props.project || !this.props.project.project)?
          null:
          <NodeInformation 
          open={this.state.openNodeInformation} 
          addNode={this.addNode} 
          updateNode={this.updateNode}
          actionDialog={this.state.actionModal}
          handleClose={this.closeNodeInformationDialog}
          nodeType={this.getTypeSelected()}
          parent={this.state.selectedItem}
          project={this.props.project}
          resetInformationConfig={this.resetInformationConfig}/>
        }
        




        <MySnackBar message={this.props.wbs.messageSnackBar} open={this.props.wbs.openSnackBar} handleClose={this.closeSnackBar} />
        <AskAlert openAlert={this.state.openDeleteAlert} handleCloseCancel={this.cancelDelete} handleCloseOk={this.removeNode}
          dialogTitle="Delete item" dialogContent="Are you sure to delete this item?" />
        <Alerta message={this.state.messageAlerta} openAlert={this.state.openAlerta} closeErrorDialog={()=>this.setState({openAlerta:false, messageAlerta:""})}/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


WorkStructure.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default 
connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(WorkStructure));


// WEBPACK FOOTER //
// ./src/features/wbs/WorkStructure.js